module.exports = __webpack_public_path__ + "static/img/diagram.b28893e8.png";